import React from 'react';

/** Official ResetProtocol shield logo. Use one of the size presets, or pass `size` for a custom px value. */
export default function Logo({ size = 32, glow = false, className = '', priority = false }) {
  const src = size <= 96
    ? '/brand/reset-logo-96.png'
    : size <= 192
      ? '/brand/reset-logo-192.png'
      : '/brand/reset-logo-512.png';
  return (
    <img
      src={src}
      alt="ResetProtocol"
      width={size}
      height={size}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      style={{ width: size, height: size }}
      className={`select-none ${glow ? 'drop-shadow-[0_0_18px_rgba(168,58,74,0.55)]' : ''} ${className}`}
    />
  );
}

/** Logo + wordmark inline, used in nav and footer. */
export function LogoMark({ size = 28, className = '', textClass = 'text-white' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <Logo size={size} />
      <span className={`font-heading text-base tracking-[0.28em] ${textClass}`} style={{ fontWeight: 600 }}>RESET</span>
    </div>
  );
}
